import React, {Component } from 'react';
import { observer } from 'mobx-react';
import Modal from 'react-bootstrap/Modal';
import { Button} from 'react-bootstrap';

import imageURLs from '../../sharedFiles/ImagesURLs';

const HelpTourImplementStart = observer(class HelpTourImplementStart extends Component {

	constructor (props) {
        super(props);
    }
	componentWillMount(){

	}


	render(){
		const {show, 
			   store,
				title,
				callBack,
				body_html,
				cancel_btn,
				save_btn,
				appStore,
				singleButton,
				logoutCss,
			    closeButtonRequired} = this.props;
		return (
			<Modal backdrop='static' className={(appStore ? appStore.selectedColor.value : '')+" "+(logoutCss ? logoutCss:"")} show = {show} aria-labelledby="contained-modal-title-vcenter" centered onHide={() => closeButtonRequired ? appStore.logout(): this.props.closePopup() }>
				  <Modal.Header closeButton>
				    <Modal.Title>{appStore.getLanguageTrans("Hello")+" "+appStore.userInfo.usersmodel.real_name}</Modal.Title>
				  </Modal.Header>

				  <Modal.Body> 
                         <p>{appStore.getLanguageTrans("Welcome to the HelpOnClick Live Chat Dashboard.")}</p>
                         <p>{appStore.getLanguageTrans("Take a step-by-step tutorial to set up your account.")}</p>
				  </Modal.Body>

				  <Modal.Footer>
				  <Button className="btn_cancel" type="button" variant="secondary" onClick={() => this.props.closePopup()} >{appStore.getLanguageTrans("Cancel")}</Button>
				    <Button className="btn_save"  type="button" variant="primary" onClick={() => (this.props.closePopup(),store.goToPageFromWelcome(appStore))} >{appStore.getLanguageTrans(cancel_btn)}</Button>
				  </Modal.Footer>                      
				</Modal>
		)
	}
})
export default HelpTourImplementStart;
